<template>
  <div>
    <div style="margin:0px 20px;padding-top: 20px;">
      <img
        src="./images/daily_logoH.png"
        alt=""
        style="width:130px;height:40px"
      >
    </div>
    <div id="content" >
      <!-- v-loading="loading" customClass="loadingH5" -->
      <!--这是标题-->
      <div class="title">
        <p id="title">
          {{title}}主题报告
        </p>
      </div>
      <!--<hr color="#827255" size="3" style="margin: 0 25px;"/>-->

      <!--舆情概述的说明文字-->
      <div class="container">
        <p>
          与{{ dataSpecial.keys }}相关的舆情从{{
                dataSpecial.startYear
              }}年{{ dataSpecial.startMonth }}月{{
                dataSpecial.startDate
              }}日00时00分至{{ dataSpecial.endYear }}年{{
                dataSpecial.endMonth
              }}月{{ dataSpecial.endDate }}日{{ dataSpecial.endShi }}时{{
                dataSpecial.endFen
              }}分共计
          {{ dataSpecial.total }}条，根据每日数据统计，其中媒体渠道发布共{{
                dataSpecial.mediaNum
              }}条、微信发布共{{ dataSpecial.weixinNum }}条、微博发布共{{
                dataSpecial.microNum
              }}
          条、论坛发布共{{ dataSpecial.bbsNum }}条、视频发布共{{
                dataSpecial.shipinNum
              }}
          条、app发布共{{ dataSpecial.appNum }}条。单日峰值信息为{{
                dataSpecial.maxNum
              }}条。
        </p>
      </div>

      <!--舆情走势-->
      <div
        id="yuqingZoushi"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">舆情走势</div>
        <div
          class="showBox"
          v-if="chartdata"
        >
          <p class="shuoming"></p>
          <zoushi
            class="yuqingbox"
            id="yuqingbox"
            :zoushiList="chartdata"
          ></zoushi>
        </div>
        <div
          class="hideBox"
          v-else
        >此模块无数据</div>
      </div>

      <!--敏感-->
      <div
        id="yuqingZhanbi"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">敏感占比</div>
        <div
          class="showBox"
          v-if="charmap"
        >
          <p class="shuoming"></p>
          <zhanbi
            :zhanbiList="charmap"
            class="yuqingZhanbibox"
            id="yuqingZhanbibox"
          ></zhanbi>
        </div>
        <div
          class="hideBox"
          v-else
        >此模块无数据</div>
      </div>

      <!-- 渠道来源 -->
      <div
        id="qudaoYuanc"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">渠道来源</div>
        <div
          class="showBox"
          v-if="originaldata"
        >
          <p class="shuoming"></p>
          <laiyuan
            class="qudaobox"
            id="qudaobox"
            :laiyuanList="originaldata"
          ></laiyuan>
        </div>
        <div
          class="hideBox"
          v-else
        >此模块无数据</div>
      </div>
      <!-- 地域信息 -->
      <div
        id="qudaoYuanc"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">地域信息</div>
        <div
          class="showBox"
          v-show="mapList.length>0"
        >
          <p class="shuoming"></p>
          <maps
            class="qudaobox"
            id="qudaobox"
            :mapList="mapList"
            style="height: 160rem;display: flex;flex-direction: column;"
          ></maps>
        </div>
        <div
          class="hideBox"
          v-if="mapList.length<=0"
        >此模块无数据</div>
      </div>

      <!-- 词云 -->
      <div
        id="mingangNews"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">词云</div>
        <div
          class="showBox"
          v-show="ciyun.length>0"
        >
          <p class="shuoming"></p>
          <ciyun
            class="mingangbox"
            id="mingangbox"
            style="height:80rem"
            :ciyun="ciyun"
          ></ciyun>
        </div>
        <div
          class="hideBox"
          v-if="ciyun.length<=0"
        >此模块无数据</div>
      </div>
      <!-- 传播层级分析 -->
      <div
        id="qudaoYuanc"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">传播层级分析</div>
        <div
          class="showBox"
          v-show="Hierarchy.length>0"
        >
          <p class="shuoming"></p>
          <jzt
            class="qudaobox"
            id="qudaobox"
            :Hierarchy="Hierarchy"
          ></jzt>
        </div>
        <div
          class="hideBox"
          v-if="Hierarchy.length<=0"
        >此模块无数据</div>
      </div>

      <!--热点新闻TOP5(月报)-->
      <div
        id="hotNesTop"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">热点新闻top5</div>
        <div
          class="showBox"
          v-show="text.datas.length>0"
        >
          <p class="shuoming">{{text.hotspotText}}</p>
          <div id="hotNesTopList">
            <topNum :topList="text.datas"></topNum>
          </div>
        </div>
        <div
          class="hideBox"
          v-if="text.datas.length<=0"
        >此模块无数据</div>
      </div>
      <!--热点微博Top5-->
      <div
        id="hotNesTop"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">热点微博Top5</div>
        <div
          class="showBox"
          v-show="weibo.length>0"
        >
          <p class="shuoming">{{text.hotspotText}}</p>
          <div id="hotNesTopList">
            <topNum :topList="weibo"></topNum>
          </div>
        </div>
        <div
          class="hideBox"
          v-if="weibo.length<=0"
        >此模块无数据</div>
      </div>

      <!--热点视频Top5-->
      <div
        id="hotNesTop"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">热点视频Top5</div>
        <div
          class="showBox"
          v-show="video.length>0"
        >
          <p class="shuoming">{{text.hotspotText}}</p>
          <div id="hotNesTopList">
            <topNum :topList="video"></topNum>
          </div>
        </div>
        <div
          class="hideBox"
          v-if="video.length<=0"
        >此模块无数据</div>
      </div>
      <!-- 微信Top5 -->
      <div
        id="minganZimeiti"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">微信Top5</div>
        <div
          class="showBox"
          v-show="weixinList.length>0"
        >
          <p class="shuoming"></p>
          <weixin
            class="minggaoMeitibox"
            id="minggaoMeitibox"
            :weixinList="weixinList"
          ></weixin>
        </div>
        <div
          class="hideBox"
          v-if="weixinList.length<=0"
        >此模块无数据</div>
      </div>

      <div
        id="minganZimeiti"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">活跃网民</div>
        <div
          class="showBox"
          v-show="allWm.length>0"
        >
          <p class="shuoming"></p>
          <netizen
            class="minggaoMeitibox"
            id="minggaoMeitibox"
            style="height:150rem"
            :wmList="allWm"
          ></netizen>
        </div>
        <div
          class="hideBox"
          v-if="allWm.length<=0"
        >此模块无数据</div>
      </div>

      <div
        id="minganZimeiti"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">活跃微信网民</div>
        <div
          class="showBox"
          v-show="weixinWm.length>0"
        >
          <p class="shuoming"></p>
          <netizen
            class="minggaoMeitibox"
            id="minggaoMeitibox"
            style="height:150rem"
            :wmList="weixinWm"
          ></netizen>
        </div>
        <div
          class="hideBox"
          v-if="weixinWm.length<=0"
        >此模块无数据</div>
      </div>

      <div
        id="minganZimeiti"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">活跃微博网民</div>
        <div
          class="showBox"
          v-show="weiboWm.length>0"
        >
          <p class="shuoming"></p>
          <netizen
            class="minggaoMeitibox"
            id="minggaoMeitibox"
            style="height:150rem"
            :wmList="weiboWm"
          ></netizen>
        </div>
        <div
          class="hideBox"
          v-if="weiboWm.length<=0"
        >此模块无数据</div>
      </div>

      <div
        id="minganZimeiti"
        style="margin:0 20px 25px;"
      >
        <div class="mokuaiTitle">活跃论坛网民</div>
        <div
          class="showBox"
          v-show="bbsWm.length>0"
        >
          <p class="shuoming"></p>
          <netizen
            class="minggaoMeitibox"
            id="minggaoMeitibox"
            style="height:150rem"
            :wmList="bbsWm"
          ></netizen>
        </div>
        <div
          class="hideBox"
          v-if="bbsWm.length<=0"
        >此模块无数据</div>
      </div>

      <p style="text-align: center">已经到底了</p>
    </div>

    <!-- <div
      id="loading"
      style="width:100px;height:100px;margin: auto;border:0px solid red;text-align: center;margin-top: 100px"
    >
      <img
        src="./images/loading.gif"
        alt=""
      >
    </div> -->
  </div>
</template>
<script>
import axios from "axios";
import echart from "echarts";
import ReportApi from "@/api/report.js";
import Cookies from "js-cookie";
import topNum from "./component/topNum.vue";
import zoushi from "./component/yuqingzoushi.vue";
import zhanbi from "./component/zhanbi.vue";
import laiyuan from "./component/laiyuan.vue";
import maps from "./component/map.vue";
import ciyun from "./component/ciyun.vue";
import jzt from "./component/jinzita.vue";
import weixin from "./component/weixinTop.vue";
import netizen from "./component/netizen.vue";
import qs from "qs"
export default {
  components: {
    zoushi,
    zhanbi,
    laiyuan,
    topNum,
    ciyun,
    maps,
    jzt,
    weixin,
    netizen
  },
  data() {
    return {
      fullscreenLoading: false,
      loading:false,
      querInfo: {
        keyWord: "",
        attachKeyWord: "",
        starDate: "",
        endDate: ""
      },
      title: "",
      dataSpecial: {},
      text: {
        datas: []
      },
      datalist: [],

      // 舆情走势/数据分析
      chartdata: [],
      charmap: [], //占比
      originaldata: [], //来源渠道

      ciyun: [],
      weibo: [], //热点微博Top5
      video: [], //热点视频
      mapList: [], //地图
      Hierarchy: [], //传播层级/金字塔
      weixinList: [], //微信Top

      allWm: [], //全部网民
      weixinWm: [], //微信
      weiboWm: [], //微博
      bbsWm: [] //论坛
    };
  },
  methods: {
    getList() {
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)',
          customClass:"loadingH5"
          
        });
      var bDate = this.querInfo.starDate;
      var eDate = this.querInfo.endDate;
      var startTimeArr = bDate.split("-");
      // let info=JSON.parse(this.querInfo)
      // let bDate = info.starDate;
      // let eDate = info.endDate;
      // let startTimeArr = bDate.split("-");
      let bbsNum = 0,
        mediaNum = 0,
        weixinNum = 0,
        microNum = 0,
        shipinNum = 0,
        appNum = 0,
        total = 0,
        maxNum = 0;
      let totalArr = [];
      ReportApi.zhut((this.querInfo), true).then(data => {
        // this.loading=true
        
        
        let bigtitle = data.returnData.title;
        total = data.returnData.dataList.length;
        var typeNum = data.returnData.typeNum;
        mediaNum = typeNum.News;
        weixinNum = typeNum.WeiXin;
        microNum = typeNum.Micro;
        bbsNum = typeNum.BBS;
        shipinNum = typeNum.Video;
        appNum = typeNum.APP;
        this.datalist = data.returnData;
        for (var i = 0; i < data.returnData.dailyAnalysisList.length; i++) {
          totalArr.push(data.returnData.dailyAnalysisList[i].total);
        }
        maxNum = Math.max.apply(this, totalArr);
        this.title = this.datalist.title;
        var endTimeqianArr = data.returnData.endDate.split(" ");
        var endTimeArr = endTimeqianArr[0].split("-"), //结束时间的年月日
          endTime = endTimeqianArr[1].split(":"); //结束时间的时分秒
        var dataSpecial = {
          keys: bigtitle,
          startYear: startTimeArr[0],
          startMonth: startTimeArr[1],
          startDate: startTimeArr[2],
          endYear: endTimeArr[0],
          endMonth: endTimeArr[1],
          endDate: endTimeArr[2],
          endShi: endTime[0],
          endFen: endTime[1],
          total: total,
          mediaNum: mediaNum,
          weixinNum: weixinNum,
          microNum: microNum,
          bbsNum: bbsNum,
          maxNum: maxNum,
          shipinNum: shipinNum, //blueadd
          appNum: appNum, //blueadd
          // starDateTime:bDate,
          endDateTime: eDate
          // dataListString:dataListString,
        };
        this.dataSpecial = dataSpecial;

        
        this.chartdata = this.datalist.dailyAnalysisList;
        this.charmap = this.datalist.sensitiveRatio;
        this.originaldata = this.datalist.typeNum;
        if(this.datalist.wordCloud){
          this.ciyun = this.datalist.wordCloud;
        }else {
          this.ciyun=[]
        }
        
        //           this.ciyun=[
        //   {
        //     "name": "非洲",
        //     "value": 192,
        //     "nature": "nsf"
        //   },
        //   {
        //     "name": "发展",
        //     "value": 184,
        //     "nature": "vn"
        //   },
        //   {
        //     "name": "酒店",
        //     "value": 178,
        //     "nature": "nis"
        //   },
        //   {
        //     "name": "中非",
        //     "value": 144,
        //     "nature": "ns"
        //   },
        //   {
        //     "name": "校友",
        //     "value": 136,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "全国",
        //     "value": 135,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "服务",
        //     "value": 125,
        //     "nature": "vn"
        //   },
        //   {
        //     "name": "合作",
        //     "value": 112,
        //     "nature": "vn"
        //   },
        //   {
        //     "name": "鲲鹏",
        //     "value": 109,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "平台",
        //     "value": 104,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "建设",
        //     "value": 101,
        //     "nature": "vn"
        //   },
        //   {
        //     "name": "生态",
        //     "value": 100,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "领域",
        //     "value": 96,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "受让方",
        //     "value": 93,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "深度",
        //     "value": 93,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "要求",
        //     "value": 87,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "校友会",
        //     "value": 86,
        //     "nature": "nis"
        //   },
        //   {
        //     "name": "城市",
        //     "value": 83,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "进行",
        //     "value": 82,
        //     "nature": "vn"
        //   },
        //   {
        //     "name": "全球",
        //     "value": 78,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "湖南大学",
        //     "value": 77,
        //     "nature": "ntu"
        //   },
        //   {
        //     "name": "国家",
        //     "value": 74,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "颜卫彬",
        //     "value": 74,
        //     "nature": "nr"
        //   },
        //   {
        //     "name": "方式",
        //     "value": 73,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "中心",
        //     "value": 72,
        //     "nature": "nis"
        //   },
        //   {
        //     "name": "人员",
        //     "value": 71,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "园区",
        //     "value": 70,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "算力",
        //     "value": 67,
        //     "nature": "n"
        //   },
        //   {
        //     "name": "活动",
        //     "value": 65,
        //     "nature": "vn"
        //   },
        //   {
        //     "name": "创新中心",
        //     "value": 63,
        //     "nature": "ns"
        //   }
        // ]
        this.text.datas = this.datalist.News.splice(0, 5);
        this.weibo = this.datalist.weibo.splice(0, 5);
        this.video = this.datalist.video.splice(0, 5);
        this.weixinList = this.datalist.weCat.splice(0, 5);
        this.mapList = this.datalist.area;
        this.Hierarchy = this.datalist.newsMedia;
        
        //           this.datalist.hotSpotNetizen={
        //   "all": [
        //     {
        //       "name": "A-小辰租房",
        //       "numberOfReleases": 11,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "笑嘻嘻的木杉",
        //       "numberOfReleases": 11,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "快乐长行人",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "长沙银行资讯",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "阳光可爱丑老头",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "嗮德乌漆墨黑v租房",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "有早餐吃吗",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "金鹰纪实卫视",
        //       "numberOfReleases": 7,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "Kitty719-",
        //       "numberOfReleases": 6,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "岳麓找房",
        //       "numberOfReleases": 6,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     }
        //   ],
        //   "bbs": [
        //     {
        //       "name": "长沙银行资讯",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "吃糊感d",
        //       "numberOfReleases": 5,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "东方千钰",
        //       "numberOfReleases": 4,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "长沙银行(SH601577)",
        //       "numberOfReleases": 4,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "阿斯达塔布",
        //       "numberOfReleases": 3,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "职业投机者",
        //       "numberOfReleases": 3,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "文娇15",
        //       "numberOfReleases": 2,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "偎灶猫",
        //       "numberOfReleases": 2,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "股友a269a80027",
        //       "numberOfReleases": 2,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "红日投资东风劲",
        //       "numberOfReleases": 2,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     }
        //   ],
        //   "weixin": [
        //     {
        //       "name": "快乐长行人",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "步步高广场长沙店",
        //       "numberOfReleases": 3,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "长沙湘江爱尔眼科",
        //       "numberOfReleases": 2,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "长沙金融业联合会",
        //       "numberOfReleases": 1,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "欧普商用照明",
        //       "numberOfReleases": 1,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "酒鬼酒",
        //       "numberOfReleases": 1,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "长沙爱尔眼科医院",
        //       "numberOfReleases": 1,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "长沙银行",
        //       "numberOfReleases": 1,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "湘西长行村镇银行",
        //       "numberOfReleases": 1,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "邵阳民政",
        //       "numberOfReleases": 1,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     }
        //   ],
        //   "weibo": [
        //     {
        //       "name": "A-小辰租房",
        //       "numberOfReleases": 11,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "笑嘻嘻的木杉",
        //       "numberOfReleases": 11,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "阳光可爱丑老头",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "嗮德乌漆墨黑v租房",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "有早餐吃吗",
        //       "numberOfReleases": 8,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "金鹰纪实卫视",
        //       "numberOfReleases": 7,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "Kitty719-",
        //       "numberOfReleases": 6,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "岳麓找房",
        //       "numberOfReleases": 6,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "两只眼睛两条腿",
        //       "numberOfReleases": 4,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     },
        //     {
        //       "name": "叶嘻嘻525",
        //       "numberOfReleases": 4,
        //       "poster": "http://tva1.sinaimg.cn/default/images/default_avatar_male_50.gif"
        //     }
        //   ]
        // }

        if (this.datalist.hotSpotNetizen) {
          this.allWm = this.datalist.hotSpotNetizen.all;
          this.weixinWm = this.datalist.hotSpotNetizen.weixin;
          this.weiboWm = this.datalist.hotSpotNetizen.weibo;
          this.bbsWm = this.datalist.hotSpotNetizen.bbs;
        }
        // setTimeout(()=>{
        //   this.loading=false
        // },1500)
        setTimeout(() => {
          loading.close();
        }, 2000);
      });
    }
  },
  created() {
    // let querInfo = JSON.parse(Cookies.get("zhutilist"));
    document.title="报告详情"
    let querInfo = this.$route.query
    this.querInfo = querInfo;
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
@import "./css/demo.css";
@import "./css/v-chart.css";
.container > p {
  padding: 20px 20px 25px;
  font-size: 16px;
  color: #494949;
}

.mokuaiTitle {
  font-size: 20px;
  color: #957f67;
}
#hotNesTopList {
  .items {
    display: flex;
    height: 20rem;
    border-bottom: 1px solid #e8e8e8;

    .item-img {
      width: 20%;
      padding-top: 1rem;
      text-align: center;

      img {
        width: 50px;
        height: 50px;
      }
    }
    .item-concat {
      height: 100%;
      width: 80%;
      a {
        text-decoration: none;
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: space-around;
        p {
          color: black;
        }
        span {
          color: #c1c1c1;
          font-size: 12px;
        }
      }
    }
  }
}

</style>
<style lang="scss">
#app {
  box-shadow: none;
}
.loadingH5{
  .el-loading-spinner .el-loading-text{
    color: #409EFF !important;
  }
}
</style>